// Coordonnées GPS des 30 villes pour la carte interactive.
// Source : OpenStreetMap (Nominatim).
export const CITY_COORDS = {
  "saint-malo": [48.6493, -2.0258],
  "dinard": [48.6311, -2.0617],
  "cancale": [48.6772, -1.8531],
  "dinan": [48.4544, -2.0461],
  "saint-briac-sur-mer": [48.6200, -2.1500],
  "saint-lunaire": [48.6378, -2.1106],
  "saint-coulomb": [48.6736, -1.9219],
  "saint-meloir-des-ondes": [48.6383, -1.9047],
  "dol-de-bretagne": [48.5494, -1.7522],
  "mont-dol": [48.5642, -1.7283],
  "pleboulle": [48.6311, -2.2425],
  "ploubalay": [48.5806, -2.1464],
  "saint-cast-le-guildo": [48.6356, -2.2553],
  "lancieux": [48.6097, -2.1500],
  "saint-jacut-de-la-mer": [48.5994, -2.1869],
  "matignon": [48.5969, -2.3050],
  "crehen": [48.5806, -2.2350],
  "plancoet": [48.5239, -2.2300],
  "saint-lormel": [48.5689, -2.2306],
  "languenan": [48.5161, -2.1294],
  "pleudihen-sur-rance": [48.5028, -1.9614],
  "corseul": [48.4783, -2.1683],
  "pluduno": [48.5589, -2.2147],
  "saint-jouan-des-guerets": [48.5994, -1.9772],
  "pleurtuit": [48.5806, -2.0656],
  "chateauneuf-d-ille-et-vilaine": [48.5800, -1.9000],
  "saint-benoit-des-ondes": [48.6164, -1.8472],
  "la-richardais": [48.6056, -2.0367],
  "le-minihic-sur-rance": [48.5750, -2.0117],
  // Morbihan
  "damgan": [47.5167, -2.5833],
  "la-roche-bernard": [47.5197, -2.3036],
  "ambon": [47.5500, -2.5500],
  "marzan": [47.5333, -2.3667],
  "peaule": [47.6372, -2.3433],
  "muzillac": [47.5611, -2.4778],
};
